import { RefObject } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { useDetailTableHandlers as useCommonDetailTableHandlers } from 'src/hooks/useDetailTableHandlers';
import { useCodeSearch } from 'src/hooks/useCodeSearch';
import { createModuleConfig } from 'src/utils/detail-table/detailTableUtils';
import { EQM3020_R01Dto } from '../Dto_EQM3020_R01';

interface Props {
	EQM3020_R01List: EQM3020_R01Dto[];
	originalEQM3020_R01List: EQM3020_R01Dto[];
	updateEQM3020_R01List: (index: number, data: EQM3020_R01Dto) => void;
	gridRef: RefObject<AgGridReact<EQM3020_R01Dto> | null>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any -- 코드검색 모달 props 타입이 화면별로 상이함
	setCodeSearchModalProps: any;
}

export function useEQM3020_R01CellChange({
	EQM3020_R01List,
	originalEQM3020_R01List,
	updateEQM3020_R01List,
	gridRef,
	setCodeSearchModalProps,
}: Props) {
	const { searchExactCode } = useCodeSearch({});
	const moduleConfig = createModuleConfig.EQM3020();

	const fieldConfigWithSearch = {
		...moduleConfig.fieldConfig,
		codeSearchFields: {
			...moduleConfig.fieldConfig.codeSearchFields,
			empNo: {
				...moduleConfig.fieldConfig.codeSearchFields!.empNo,
				searchFunction: (code: string, onSuccess?: (item: unknown) => void) =>
					searchExactCode('employee', code, onSuccess),
			},
		},
	};

	const calculateAmount = (data: EQM3020_R01Dto): EQM3020_R01Dto => data;

	return useCommonDetailTableHandlers<EQM3020_R01Dto>({
		detailList: EQM3020_R01List,
		updateDetailList: updateEQM3020_R01List,
		originalDetailList: originalEQM3020_R01List,
		setCodeSearchModalProps,
		gridRef,
		fieldConfig: fieldConfigWithSearch,
		codeSearchConfig: moduleConfig.codeSearchConfig,
		calculateAmount,
	});
}
